import { connect } from 'react-redux';
import { changeAdminSettings } from '@actions/admin';
import { push as pushFromSidebar, openSidebar, closeSidebar } from '@actions/sidebar';
import { logout } from '@actions/authentication';
import { isSuperAdmin } from '@selectors/authentication';
import { selectSettings } from '@selectors/admin';
import { isSidebarActive } from '@selectors/sidebar';
import { Sidebar } from './Sidebar';

const mapStateToProps = (state) => ({
  isSuperAdmin: isSuperAdmin(state),
  active: isSidebarActive(state),
  email: state.authentication.email,
  ...selectSettings(state),
  path: state.router.location.pathname,
});

const mapDispatchToProps = (dispatch) => ({
  pushFromSidebar: (args) => dispatch(pushFromSidebar(args)),
  openSidebar: () => dispatch(openSidebar()),
  closeSidebar: (active) => dispatch(closeSidebar(active)),
  logoutOnClick: () => dispatch(logout()),
  toggleDeletingOldConferences: (value, reason) =>
    dispatch(changeAdminSettings({ key: 'shouldDeleteOldConferences', value, reason })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Sidebar);



// WEBPACK FOOTER //
// ./components/organisms/Sidebar/index.js